import { connect } from 'react-redux';
import EnhancedFormGroup from './EnhancedFormGroup.jsx';
import makeSelectAtLeastOneFieldInArrayIsVisible from '#selectors/ui/form/support/makeSelectAtLeastOneFieldInArrayIsVisible.js';

const makeMapStateToProps = () => {
  let selectAtLeastOneFieldInArrayIsVisible = null;
  let currentForm = null;

  return (state, ownProps) => {
    const { fields, form } = ownProps;

    // Create selector only when form changes
    if (form !== currentForm) {
      currentForm = form;
      selectAtLeastOneFieldInArrayIsVisible = form
        ? makeSelectAtLeastOneFieldInArrayIsVisible(form)
        : null;
    }

    return {
      visible: form && fields ? selectAtLeastOneFieldInArrayIsVisible(state, { fields }) : true,
    };
  };
};

export default connect(makeMapStateToProps)(EnhancedFormGroup);
